import type { BotGiftClaimDto, BotGiftDto } from "../api/dto/bot_gift.dto.js";
import { claimBotGift } from "../api/requests/bot_gift.requests.js";
import { ApiError } from "../api/http_client.js";

export class BotGiftService
{
  private static pending: BotGiftDto | null = null;

  private constructor() {}

  public static setPending( gift: BotGiftDto | null | undefined ): void
  {
    BotGiftService.pending = gift && gift.rewards.length > 0 ? gift : null;
  }

  public static hasPending(): boolean
  {
    return BotGiftService.pending !== null;
  }

  public static async claim(): Promise<BotGiftClaimDto>
  {
    const gift = BotGiftService.pending;
    if ( !gift )
      throw new ApiError( 409, "nothing_to_claim" );

    try
    {
      const result = await claimBotGift( gift.id );
      BotGiftService.pending = null;
      return result;
    }
    catch ( e )
    {
      if ( e instanceof ApiError && e.status === 409 )
        BotGiftService.pending = null;
      throw e;
    }
  }
}
